import { Dialog, DialogTitle, DialogContent, DialogActions, Fab } from "@mui/material";
import ContentBox from "./ContentBox";

const AbortDialog = ({
  abortOpen,
  setAbortOpen,
  isDuplicateKeyword,
  inputKeyword,
  duplicateMisspellingsWord,
  handleAbortClose
}) => (
  <Dialog
    open={abortOpen}
    onClose={() => setAbortOpen(false)}
    PaperProps={{
      sx: {
        width: { xs: '90%', sm: 600 },
        p: 2,
      },
    }}
    BackdropProps={{ sx: { backgroundColor: "rgba(128, 128, 128, 1)" }}}
  >
    <DialogTitle
      sx={{
        fontWeight: "bold",
        fontSize: "1.5rem",
        color: "rgba(0, 0, 0, 0.8)"
      }}
    >
      Cannot add. The following already exist in the table
    </DialogTitle>
    <DialogContent>
      <ContentBox
        word={"Word"}
        description={"Already in list as.."}
        isHeading={true}
      />
      {isDuplicateKeyword && (
        <ContentBox
          word={inputKeyword.toLowerCase()}
          description={"Keyword"}
          isHeading={false}
        />
      )}
      {duplicateMisspellingsWord.map((keywords, index) => (
        <ContentBox
          word={keywords.misspelling}
          description={`Misspelling for keyword ${keywords.text}`}
          isHeading={false}
          key={index}
        />
      ))}
    </DialogContent>
    <DialogActions>
      <Fab
        color="primary" size="medium" variant="extended"
        onClick={handleAbortClose}
        sx={{
          px: 4,
        }}
      >
        &nbsp;ABORT
      </Fab>
    </DialogActions>
  </Dialog>
);

export default AbortDialog;
